import { IFormRender } from '@busybusy/webapp-react-ui';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import SectionHeader from 'containers/settings/components/SectionHeader/SectionHeader';
import AllowKioskModeFormFields from 'containers/settings/positions/components/AllowKioskModeFormFields/AllowKioskModeFormFields';
import ClockInRestrictionFormFields from 'containers/settings/positions/components/ClockInRestrictionFormFields/ClockInRestrictionFormFields';
import JobCostingPromptFormFields from 'containers/settings/positions/components/JobCostingPromptFormFields/JobCostingPromptFormFields';
import RequestTimeOffFormFields from 'containers/settings/positions/components/RequestTimeOffFormFields/RequestTimeOffFormFields';
import RequireEquipmentFormFields from 'containers/settings/positions/components/RequireEquipmentFormFields/RequireEquipmentFormFields';
import { RequireEquipmentFormHeaderText } from 'containers/settings/positions/components/RequireEquipmentFormHeaderText/RequireEquipmentFormHeaderText';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';
import PhotoVerificationSettingsFormFields from '../../PhotoVerificationSettingsFormFields';
import { ICreatePositionsFormData } from '../CreatePositionForm';
import './CreatePositionOtherSection.scss';

export interface ICreatePositionOtherSectionProps {
  form: IFormRender<ICreatePositionsFormData>;
}

function CreatePositionOtherSection({ form }: ICreatePositionOtherSectionProps) {
  const requireEquipmentEnabled = useFeatureFlags('REQUIRE_EQUIPMENT_POSITION_SETTING');

  return (
    <>
      <SectionHeader className="mb-4">{t('Other')}</SectionHeader>

      <HeaderText title={t('Clock In Restriction')} className="mb-4">
        {t('Prevent employees from clocking in before a specified time, or without a scheduled work item.')}
      </HeaderText>
      <ClockInRestrictionFormFields form={form} />

      <ConditionalContainer condition={requireEquipmentEnabled}>
        <RequireEquipmentFormHeaderText className="mb-4" />
        <RequireEquipmentFormFields form={form} />
      </ConditionalContainer>

      <div className="mb-4">
        <PhotoVerificationSettingsFormFields form={form} />
      </div>

      <div className="my-4">
        <RequestTimeOffFormFields form={form} />
      </div>
      <div className="my-4">
        <JobCostingPromptFormFields form={form} />
      </div>
      <div className="my-4">
        <AllowKioskModeFormFields form={form} />
      </div>
    </>
  );
}

export default CreatePositionOtherSection;
